import { render } from "./onboarding-personalize.vue?vue&type=template&id=f7db602e"
import script from "./onboarding-personalize.vue?vue&type=script&lang=js"
export * from "./onboarding-personalize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__